import React from "react";

export function Footertwitter() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_1849_690)">
        <path d="M12.8025 11.5903L18.2033 19.3155H15.9868L11.5796 13.0118V13.0114L10.9325 12.086L5.78418 4.72168H8.00071L12.1554 10.665L12.8025 11.5903Z" fill="#698ACD" />
        <path d="M21.4067 0H2.59325C1.16108 0 0 1.16108 0 2.59325V21.4067C0 22.8389 1.16108 24 2.59325 24H21.4067C22.8389 24 24 22.8389 24 21.4067V2.59325C24 1.16108 22.8389 0 21.4067 0ZM15.308 20.3525L10.8481 13.8617L5.26435 20.3525H3.82122L10.2073 12.9295L3.82122 3.63521H8.69203L12.9152 9.78152L18.2026 3.63521H19.6458L13.5562 10.7139H13.5558L20.1788 20.3525H15.308Z" fill="#698ACD" />
      </g>
      <defs>
        <clipPath id="clip0_1849_690">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
